import { render } from "./TotalList.vue?vue&type=template&id=cbc0b700&scoped=true"
import script from "./TotalList.vue?vue&type=script&lang=js"
export * from "./TotalList.vue?vue&type=script&lang=js"

import "./TotalList.vue?vue&type=style&index=0&id=cbc0b700&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/vas-web-client-pre/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbc0b700"]])